export default __webpack_public_path__ + "static/media/KOD0021-min.76a66ec7.webp";